<template>
  <el-dialog
    :title="getTitle()"
    :visible="isDiaShow"
    width="60%"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="110px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-form-item label="标题" prop="Title">
        <el-input v-model="rootInfo.title" maxlength="50" disabled />
      </el-form-item>
      <el-form-item label="聊天记录">
        <div id="msglist" style="height:300px;overflow-y:auto;">
          <div v-for="(item,idx) in msgList" :key="idx" style="display:block">
            <div v-if="!item.isRight">
              <span style="">{{ item.userName }} *{{ item.sendDT }}*</span>
              <span style="background:#DCDCDC;padding:8px">{{ item.content }}</span>
            </div>
            <div v-if="item.isRight" style="text-align: right;">
              <span style="background:#32CD32;padding:8px">{{ item.content }}</span>
              <span style="">{{ item.userName }} *{{ item.sendDT }}*</span>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="内容" prop="Content">
        <el-input v-model="entityData.Content" type="textarea" :rows="5" maxlength="100" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSend()">发  送</el-button>
      <el-button style="float:left" type="success" @click="handleGetData()">刷 新</el-button>
    </div>

  </el-dialog>
</template>
<script>
import pathReq from '@/api/pathlist'
import { parseTime } from '@/utils'
export default {
  data() {
    return {
      isDiaShow: false,
      entityData: {
        Content: ''
      },
      toUserId: null,
      toUserName: '',
      rules: {
        Content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      rootId: null,
      rootInfo: {},
      msgList: []
    }
  },
  methods: {
    parseTime,
    getTitle() {
      return this.toUserName + '私信记录'
    },
    showDialog(rootId) {
      const that = this
      that.rootId = rootId
      this.handleGetData()

      this.isDiaShow = true
    },
    handleClose() {
      this.$refs.entityData.resetFields()
      this.isDiaShow = false
    },
    /** 发送 */
    handleSend() {
      const that = this
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          var data = {
            msgRootId: that.rootId,
            content: this.entityData.Content
          }
          var path = '/api/services/app/WorkNotification/Notify04Reply'
          pathReq.dataUpdate(path, data).then((r) => {
            that.$refs.entityData.resetFields()
            // that.isDiaShow = false
            that.handleGetData()
          })
        }
      })
    },
    /** 取得聊天数据 */
    handleGetData() {
      const that = this
      var path = '/api/services/app/WorkNotification/GetNotify04'
      pathReq.getList(path, { id: that.rootId }).then(r => {
        that.rootInfo = r.data.result.rootMsgInfo
        that.msgList = r.data.result.msgList
      }).then(_ => {
        that.$nextTick(_ => {
          var div = document.getElementById('msglist')
          div.scrollTop = div.scrollHeight
        })
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
